var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("notificationModalController", [
    "$rootScope",
    "$scope",
    "$window",
    "modalService",
    "cartService",
    "$timeout",
    "validationService",
    "loaderService",
    function ($rootScope, $scope, $window, modalService, cartService, $timeout, validationService, loaderService) {
        //#region Fields

        //#region Notification Modal
        $scope.notificationModal = {
            callbackOnCloseEmitName: null,
            callbackOnCloseFunc: null,
            callbackOnOkEmitName: null,
            callbackOnOkFunc: null,
            data: [],
            hideClose: false,
            modalKey: null,
            redirectOnOkUrl: null,
            redirectOnCloseUrl: null,
        };

        // New fields to store email values
        $scope.txtEmail = "";
        $scope.txtConfirmEmail = "";
        $scope.validationMessage = "";
        $scope.isValidForm = true;
        $scope.enableGuestCheckout = window.__env.enableGuestCheckout;
        $scope.regularExpressions = validationService.getRegularExpressions();
        $scope.showGuestCheckout = false;
        //#endregion

        //#endregion

        //#region Watch
        //#endregion

        //#region Events

        //#region Notification Modal
        $rootScope.$on("CloseNotificationModal", function (event) {
            event.stopPropagation();
            modalService.close("notificationModal");
        });

        $rootScope.$on(
            "ShowNotificationModal",
            function (event, notificationModal) {
                event.stopPropagation();
                loaderService.hide();
                $timeout(function () {
                    $scope.notificationModal = angular.copy(notificationModal);
                });

                if (notificationModal.modalKey == "loginOptions") {
                    cartService.getCustomerCart().then(function (cart) {
                        $scope.freeOrder = false;
                        if (cart.data) {
                            var cartData = cart.data;
                            var totalListPrice = cartData.reduce(function (
                                total,
                                item
                            ) {
                                return total + item.listPrice.amount;
                            },
                            0);
                            if (totalListPrice == 0) {
                                $scope.freeOrder = true;
                            }
                            modalService.open("notificationModal");
                        }
                    });
                } else {
                    modalService.open("notificationModal");
                }
            }
        );
        //#endregion

        //#endregion

        //#region Functions

        //#region Notification Modal
        $scope.close = function () {
            if (!$scope.notificationModal.hideClose) {
                modalService.close("notificationModal");
                if ($scope.notificationModal.redirectOnCloseUrl)
                    $window.location.href =
                        $scope.notificationModal.redirectOnCloseUrl;
                else if ($scope.notificationModal.callbackOnCloseEmitName)
                    $rootScope.$emit(
                        $scope.notificationModal.callbackOnCloseEmitName
                    );
                else if ($scope.notificationModal.callbackOnCloseFunc)
                    $scope.notificationModal.callbackOnCloseFunc();
            }
        };

        $scope.ok = function () {
            // Store the email values in $rootScope
            $rootScope.txtEmail = $scope.txtEmail;
            $rootScope.txtConfirmEmail = $scope.txtConfirmEmail;

            modalService.close("notificationModal");
            if ($scope.notificationModal.redirectOnOkUrl)
                $window.location.href =
                    $scope.notificationModal.redirectOnOkUrl;
            else if ($scope.notificationModal.callbackOnOkEmitName)
                $rootScope.$emit($scope.notificationModal.callbackOnOkEmitName);
            else if ($scope.notificationModal.callbackOnOkFunc)
                $scope.notificationModal.callbackOnOkFunc();
        };

        $scope.isRetryPaymentCheckout = function () {
            return ($window.location.search || "")
                .toLowerCase()
                .indexOf("retryorder=") !== -1;
        };

        $scope.contactSupport = function () {
            modalService.close("notificationModal");
            $window.location.href = "/contact";
        };

        $scope.retryPayment = function () {
            modalService.close("notificationModal");
        };

        $scope.validateEmails = function () {
            $scope.validationMessage = "";
            $scope.isValidForm = true;
            $scope.txtEmail = document.getElementById("txtEmaile").value;
            $scope.txtConfirmEmail =
                document.getElementById("txtConfirmEmaile").value;
            if (!$scope.txtEmail || !$scope.txtConfirmEmail) {
                $scope.validationMessage =
                    "Les deux champs e-mail sont requis et doivent correspondre.";
                $scope.isValidForm = false;
                return;
            }

            var emailPattern = $scope.regularExpressions.email;
            if (!emailPattern.test($scope.txtEmail)) {
                $scope.validationMessage =
                    "Veuillez entrer une adresse e-mail valide.";
                $scope.isValidForm = false;
                return;
            }

            if (
                $scope.txtEmail.toLowerCase() !=
                $scope.txtConfirmEmail.toLowerCase()
            ) {
                $scope.validationMessage =
                    "Les adresses e-mail ne correspondent pas. Veuillez vérifier et réessayer.";
                $scope.isValidForm = false;
                return;
            }
        };

        $scope.proceedToGuestCheckout = function () {
            loaderService.show();
            $scope.validateEmails();
            if (!$scope.isValidForm) {
                loaderService.hide();
                return;
            } else {
                cartService
                    .guestCheckoutAccess(
                        document.getElementById("txtEmaile").value
                    )
                    .then(
                        function (response) {
                            if (response.data) {
                                $window.location.href =
                                    "/cart/checkout/shipping";
                            } else {
                                $scope.validationMessage =
                                    "Le checkout invité n'est pas disponible. Veuillez créer un compte pour procéder au checkout.";
                                $scope.isValidForm = false;
                                loaderService.hide();
                            }
                        },
                        function (error) {
                            $scope.validationMessage =
                                "Erreur lors du traitement de la demande. Veuillez réessayer.";
                            $scope.isValidForm = false;
                            loaderService.hide();
                        }
                    );
            }
        };

        $scope.closeAndRedirectToCart = function () {
            modalService.close("notificationModal");
            $window.location.href = "/cart";
        }
        $scope.saveOrder = function () {
            $rootScope.$emit("SaveOrder");
        }
        $scope.closeAndRedirectToLogin = function () {
            modalService.close("notificationModal");
            $window.location.href = "/account/login";
        };
        $scope.proceedToShowGuestCheckout = function () {
            $scope.showGuestCheckout = true;
        };

        $scope.saveOrder = function () {
            $rootScope.$emit("SaveOrder");
        };
        
        //#endregion        

        //#endregion
    },
]);
